import i18n from '18n';
import clsx from 'clsx';
import ArrowUpFromBracket from 'components/icons/ArrowUpFromBracket';
import EarlyBirdCustomSection from 'components/small/early-bird/early-bird-custom-section/EarlyBirdCustomSection';
import { DEFAULT_TOKEN_INFORMATION_DISPLAY_ITEMS, TRENDEX_ROLES } from 'config/_const';
import AssetInterface from 'model/AssetModel/AssetInterface';
import { default as React, useMemo } from 'react';
import { connect } from 'react-redux';
import IAssetCurrentInformationData from 'service/asset-current-information/IAssetCurrentInformationData';
import Utils from 'utils/Utils';
import AssetViewModel from 'view-model/Assets/AssetViewModel';
import AvatarViewModel from 'view-model/AvatarViewModel/AvatarViewModel';
import EarlyBirdSection from '../../small/early-bird/early-bird-section/EarlyBirdSection';
import TokenInformation from '../token-information/TokenInformation';
import CustomProfilBannerProps from './CustomProfilBannerProps';
import './ProfilBanner.scss';

const CustomProfilBanner: React.FC<CustomProfilBannerProps> = (props) => {
    const asset = useMemo<AssetInterface | undefined>(() => {
        return props.assets.data?.find((asset: AssetInterface) => asset._id === props.assetId)
    }, [props.assets, props.assetId]);
    const authUserReferralId: string | null = props.auth.data.isAuthenticated ? props.auth.data.account.referral.ownReferralId : null;
    const isInitialSaleDateBeforeToday: boolean = asset?.initialSaleDate ? new Date(asset.initialSaleDate).getTime() < new Date().getTime() : false;
    const assetViewModel: AssetViewModel = React.useMemo(() => new AssetViewModel(asset!), [asset]);
    const showBenzemaEarlyBirdBanner: boolean = React.useMemo(() => {
        return assetViewModel.isCustomBenzemaProfilPageBeforePublicSales();
    }, [assetViewModel, props.preSaleIsOpen]);
    const isPrimaryMarketWillStart: boolean = React.useMemo(() => {
        return Boolean(!props.privateSellIsOpen && !assetViewModel.InitialSaleDone && assetViewModel.InitialSaleDate);
    }, [props.privateSellIsOpen, assetViewModel.InitialSaleDone, assetViewModel.InitialSaleDate]);

    const isCurrentAssetInformationApplicable = (currentInfo: IAssetCurrentInformationData): boolean => {
        return Boolean(currentInfo);
    }

    const assetInfo = useMemo<{ availableSupply: number, price: number }>(() => {
        if (!asset)
            return { availableSupply: 0, price: 1 }
        const assetCurrentInfo = props.assetsCurrentInformation.data[asset._id] && Utils.removeUndefinedAndNullFromObject(props.assetsCurrentInformation.data[asset._id]);
        const defaultAssetInfo = { currentValue: asset.currentValue, secondaryMarketSupply: asset.secondaryMarketSupply, availableSupply: asset.availableSupply };
        const selectedAssetInfo = isCurrentAssetInformationApplicable(assetCurrentInfo) ? { ...defaultAssetInfo, ...assetCurrentInfo } : defaultAssetInfo;
        const assetViewModel = new AssetViewModel(asset);

        if (assetViewModel.ForcedSecondaryMarket)
            return { availableSupply: AssetViewModel.getSupplyByStage(assetViewModel, selectedAssetInfo.secondaryMarketSupply) ?? 0, price: selectedAssetInfo.currentValue };
        if (!assetViewModel.InitialSaleDone)
            return { availableSupply: selectedAssetInfo?.availableSupply, price: selectedAssetInfo.currentValue }
        if (assetViewModel.InitialSaleDone)
            return { availableSupply: selectedAssetInfo.secondaryMarketSupply ?? 0, price: selectedAssetInfo.currentValue }


        return { availableSupply: 0, price: selectedAssetInfo.currentValue }
    }, [asset, props.assetsCurrentInformation, props.preSaleIsOpen])

    const assetBackgroundViewModel: AvatarViewModel = React.useMemo(() => new AvatarViewModel({ assetCategories: props.assetsCategories.data, asset: { avatarPath: asset?.icon ?? "", mainCategoryId: asset?.mainCategory ?? "", cardLevel: asset?.cardLevel! } }), [asset]);
    if (props.auth.data.account.type === TRENDEX_ROLES.ADMIN && !asset)
        return (
            <div className="asset-profil-header" style={{ backgroundColor: '#333333', zIndex: -1 }}>
                {props.CustomBottomBar}
            </div>
        );

    return (
        <div className={clsx("asset-profil-header", { 'benzema-before-public-sale': assetViewModel.isCustomBenzemaProfilPageBeforePublicSales() })}>
            <div className='asset-profil-header-share'><ArrowUpFromBracket className='hover' onClick={() => {
                const hasInitialSupply = asset?.initialSupply;
                const shareMessage = (hasInitialSupply && isInitialSaleDateBeforeToday) ? 'Share.assetPossibleToBet' : 'Share.assetResaleAvailableSoon';
                const translation = i18n.t(shareMessage, { name: asset?.name ?? "" })
                if (props.actionShare !== undefined) {
                    props.actionShare(
                        translation,
                        translation,
                        Utils.referralLinkToAsset(asset?.slug ?? "", authUserReferralId),
                        shareMessage,
                    );
                }
            }} />
            </div>
            {!showBenzemaEarlyBirdBanner && <EarlyBirdSection assetBackgroundViewModel={assetBackgroundViewModel} assetViewModel={assetViewModel} isPrimaryMarketWillStart={isPrimaryMarketWillStart} preSaleIsOpen={props.preSaleIsOpen} setPreSaleIsOpen={props.setPreSaleIsOpen} setPrivateSellIsOpen={props.setPrivateSellIsOpen} />}
            {showBenzemaEarlyBirdBanner && <EarlyBirdCustomSection assetViewModel={assetViewModel} isPrimaryMarketWillStart={isPrimaryMarketWillStart} setPreSaleIsOpen={props.setPreSaleIsOpen} setPrivateSellIsOpen={props.setPrivateSellIsOpen} />}
            {
                asset &&
                <div className='token-information-container'>
                    <TokenInformation
                        preSaleIsOpen={props.preSaleIsOpen}
                        asset={assetViewModel}
                        availableSupply={assetInfo.availableSupply}
                        totalTokensInCirculation={asset.initialSupply}
                        tokenPrice={assetInfo.price}
                        displayItems={DEFAULT_TOKEN_INFORMATION_DISPLAY_ITEMS} />
                </div>
            }
        </div >
    );
};

const mapStateToProps = (state: CustomProfilBannerProps) => ({
    auth: state.auth,
    assets: state.assets,
    assetsCategories: state.assetsCategories,
    secondaryMarket: state.secondaryMarket,
    assetsCurrentInformation: state.assetsCurrentInformation
});

export default connect(mapStateToProps)(CustomProfilBanner);
